type ResponseErrorBody = {
  error?: unknown
  errors?: unknown
  message?: unknown
}

const getMessages = (value: unknown): string[] => {
  if (typeof value === 'string') {
    const message = value.trim()
    return message ? [message] : []
  }

  if (Array.isArray(value)) {
    return value.flatMap(getMessages)
  }

  if (value && typeof value === 'object') {
    return Object.values(value).flatMap(getMessages)
  }

  return []
}

const applyRequestTerminology = (message: string): string =>
  message.replace(/\bjobs?\b/gi, (word) => {
    const request = word.toLowerCase().endsWith('s') ? 'requests' : 'request'
    return word.startsWith('J') ? request.replace(/^r/, 'R') : request
  })

const getMessage = (value: unknown): string | null => {
  const message = getMessages(value).join(' ')
  return message ? applyRequestTerminology(message) : null
}

export const getApiErrorMessage = async (error: unknown): Promise<string | null> => {
  if (!(error instanceof Response)) {
    return null
  }

  try {
    const body = (await error.clone().json()) as unknown
    if (!body || typeof body !== 'object' || Array.isArray(body)) {
      return getMessage(body)
    }

    const { error: apiError, errors, message } = body as ResponseErrorBody
    return getMessage(apiError) ?? getMessage(errors) ?? getMessage(message)
  } catch {
    // Fall through to plain text parsing below.
  }

  try {
    return getMessage(await error.clone().text())
  } catch {
    return null
  }
}
